<div class="avi-data-grid-column-selection">
    <button
        type="button"
        avi-tooltip
        [showOnClick]="true"
        [tooltipControl$]="columnSelectionCloseButtonControl$"
        [positionsPriority]="viewColumnPanelPositions"
        class="avi-data-grid-column-selection__view-columns-btn"
    >
        <cds-icon
            shape="view-columns"
            class="avi-data-grid-column-selection__view-columns-icon"
        ></cds-icon>
        <ng-template #aviTooltipContent>
            <div
                cdkTrapFocus
                [cdkTrapFocusAutoCapture]="true"
                class="avi-data-grid-column-selection__panel clr-wrapper"
            >
                <div class="avi-data-grid-column-selection__content">
                    <div class="avi-data-grid-column-selection__header">
                        <h5>{{ l10nKeys.showColumnsHeader | vtranslate }}</h5>
                        <button
                            type="button"
                            (click)="closeColumnSelectionPanel()"
                            class="avi-data-grid-column-selection__close-btn"
                        >
                            <cds-icon
                                shape="window-close"
                                class="avi-data-grid-column-selection__close-icon"
                            ></cds-icon>
                        </button>
                    </div>
                    <div class="avi-data-grid-column-selection__list">
                        <form [formGroup]="fieldsFormGroup">
                            <clr-checkbox-container *ngFor="let field of fields">
                                <clr-checkbox-wrapper>
                                    <input
                                        clrCheckbox
                                        type="checkbox"
                                        class="sel-avi-checkbox"
                                        id="avi-data-grid-column-selection-{{ field.id }}"
                                        [formControlName]="field.id"
                                    />
                                    <label>{{ field.label }}</label>
                                </clr-checkbox-wrapper>
                            </clr-checkbox-container>
                        </form>
                    </div>
                    <cds-button
                        class="avi-data-grid__column-select-all-btn"
                        [disabled]="allFieldColumnsShown"
                        (click)="showAllFieldColumns()"
                        action="flat-inline"
                    >
                        {{ l10nKeys.columnSelectAllButton | vtranslate }}
                    </cds-button>
                </div>
            </div>
        </ng-template>
    </button>
</div>
